import React, { Fragment, useContext } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import AuthContext from '../../context/auth/authContext';
import UserContext from '../../context/user/userContext';

const Navbar = ({ title, icon }) => {
  const authContext = useContext(AuthContext);
  const userContext = useContext(UserContext);

  const { isAuthenticated, logout, user } = authContext;
  const { clearUsers } = userContext;

  const onLogout = () => {
    logout();
    clearUsers();
  };

  const authLinks = (
    <Fragment>
      <li>Hello {user && user.name}</li>
      <li>
        <Link to='/'>Users</Link>
      </li>
      {user && user.role === 'admin' ? (
        <li>
          <Link to='/clients'>Clients</Link>
        </li>
      ) : (
        <li>
          <a href='https://phonehome.cfbs-us.com:444/docs.html'>Docs</a>
        </li>
      )}
      <li>
        <Link to='/touches'>Touches</Link>
      </li>
      <li>
        <a href='#!' onClick={onLogout}>
          <i className='fas fa-sign-out-alt'></i>
          <span className='hide-sm'>Logout</span>
        </a>
      </li>
    </Fragment>
  );

  const guestLinks = (
    <Fragment>
      <li>
        <Link to='Login'>Login</Link>
      </li>
    </Fragment>
  );
  return (
    <div className='navbar bg-primary'>
      <h2>
        <i className={icon} /> {title}
      </h2>
      <ul>{isAuthenticated ? authLinks : guestLinks}</ul>
    </div>
  );
};

Navbar.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string
};

Navbar.defaultProps = {
  title: 'CFBS Phone Home',
  icon: 'fas fa-tasks'
};
export default Navbar;
